import { useOrderTypeContext } from "../Contexts/OrderTypeContext";
import TrackingService, { CheckoutTrackingProps } from "../Services/TrackingService";
export const useTrackingHook = () => {

    const { orderType } = useOrderTypeContext();

    const checkoutTracking = async (params: CheckoutTrackingProps) => {
        try {
            const trackingSevice = new TrackingService(orderType);
            const getSearch = await trackingSevice.checkoutTracking(params);
            return getSearch;
        } catch (error: any) {
            throw error;
        } 
    }

    return {
        checkoutTracking
    };
}